export interface Category {
  id: string;
  slug: string;
  name: string;
  icon: string;
  description: string;
  videoCount: number;
}

export const categories: Category[] = [
  { id: "cat-1", slug: "dianying", name: "电影", icon: "ri-film-line", description: "最新最热电影大片，高清画质畅享观影体验", videoCount: 3280 },
  { id: "cat-2", slug: "dianshiju", name: "电视剧", icon: "ri-tv-line", description: "热门电视剧全集，追剧不停歇", videoCount: 4560 },
  { id: "cat-3", slug: "zongyi", name: "综艺", icon: "ri-emotion-laugh-line", description: "爆笑综艺节目，欢乐不断", videoCount: 2150 },
  { id: "cat-4", slug: "dongman", name: "动漫", icon: "ri-ghost-line", description: "热血动漫番剧，二次元世界", videoCount: 3890 },
  { id: "cat-5", slug: "jilupian", name: "纪录片", icon: "ri-earth-line", description: "精品纪录片，探索世界奥秘", videoCount: 1620 },
  { id: "cat-6", slug: "tiyu", name: "体育", icon: "ri-basketball-line", description: "精彩体育赛事，激情无限", videoCount: 980 },
  { id: "cat-7", slug: "yinyue", name: "音乐", icon: "ri-music-line", description: "MV、演唱会、音乐节目", videoCount: 1340 },
  { id: "cat-8", slug: "youxi", name: "游戏", icon: "ri-gamepad-line", description: "游戏实况、赛事直播、攻略解说", videoCount: 2100 },
];